import values from 'lodash/fp/values'
import PropTypes from 'prop-types'


const constants = {
    DEFAULT: '',
    ERROR: 'Fetch/ACCOUNT_RECOVERY_ERROR',
    PENDING: 'Fetch/ACCOUNT_RECOVERY_PENDING',
    SUCCESS: 'Fetch/ACCOUNT_RECOVERY_SUCCESS'
}

export const types = PropTypes.oneOf(values(constants))

export default constants
